import { Link } from './Link';
import { CellValue } from './CellValue';

export function isLink(value: CellValue): value is Link {
    return !!value && typeof value === 'object' && 'hyperlink' in value;
}
